var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base"},[_c('div',{staticClass:"text-success"},[_c('feather-icon',{attrs:{"icon":""}})],1),_c('span',[_c('b',[_vm._v(_vm._s(Math.round(_vm.ongoingTarget).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")))])]),_c('div',[_vm._v("SPECIAL ONGOING TARGET")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }